import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import Accordion from 'components/Accordion/Accordion';
import './FAQs.scss';


export default (props) => {
  let defaultFaq = { section: 1, index: 0 };
  if (window.location.hash.length) {
    let values = window.location.hash.replace('#', '').split('-');
    defaultFaq = {
      section: parseInt(values[0]),
      index: parseInt(values[1])
    }
  }

  const [accordion, setAccordion] = useState(defaultFaq);

  const handleAccordionClick = (index) => {
    if (index.index === accordion.index &&
      index.section === accordion.section) index = { section: 0, index: 0 };
    setAccordion(index);
  }

  const renderFaqs = (section, faqs) => {
    return faqs.map((faq, index) => {
      let id = { section, index };
      let key = `${id.section}-${id.index}`;

      return (
        <Accordion
          id={key}
          key={key}
          open={`${accordion.section}-${accordion.index}` === key}
          onClick={handleAccordionClick.bind(this, id)}
          title={faq.question}
          answer={faq.answer}>
        </Accordion>
      )
    })
  }

  return <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>FAQs | Philadelphia - Win a brunch in New York</title>
    </Helmet>
    <section className="faqs">
      <div className='layout layout-general layout-wrapper'>
        <div className="layout-container layout-container--medium layout-container--center ">
          <h1 className="type-h1">FAQ<span className="lowercase">s</span></h1>
          {
            <>
              <div className="faqs__section">
                <h2 className="type-h3 uppercase">General promotional questions</h2>
                {
                  renderFaqs(1, [{
                    question: "1. What is the Philadelphia Brunch promotion?",
                    answer: `
                    <p>
                       Philadelphia's Brunch on-pack is a promotion that gives you the chance to win a trip to New York for you and a friend, with flights, hotel, spending money and a brunch in New York included! There are also 10 Brunch hampers available to be won. With every pack purchase, you can also download a free Philly Brunch recipe PDF by heading to the campaign website. For a full breakdown of the prizes please see the T&Cs page <a href="/terms-and-conditions">here</a>.
                    </p>`
                  }, {
                    question: "2. Who is the promotion open to?",
                    answer: `
                  <p>
                    The promotion is open to anyone 18 and over who lives in the UK, including Channel Islands and Isle of Man, and the Republic of Ireland, excluding employees of the Promoter, its agents and anyone professionally associated with this Promotion.
                  </p>
                `}, {
                    question: "3.	How can I enter/ How does it work?",
                    answer: `
                  <p>
                    To enter for the UK, simply buy any participating Philadelphia product, head to <a href="https://philadelphia-brunch.com" target="_blank" rel="noopener">philadelphia-brunch.com</a>, select your region, enter the barcode and batch code, and enter your details. The barcode and batch code can be found on the back of your participating product. If you'd like to review the full terms and conditions and product details please click <a href="/terms-and-conditions">here</a>.
                  </p>
                  <p>
                    To enter for the Republic of Ireland, simply head to <a href="https://philadelphia-brunch.com" target="_blank" rel="noopener">philadelphia-brunch.com</a>, select your region,  and enter your details including your Eircode.
                  </p>
                  <p>
                    All entries will be entered into the prize draw for the chance to win a trip to New York City and a Brunch hamper. The prize draw will take place within 5 working days after the promotion ends. The promotion ends on the 30th September 2025.
                  </p>
                `}, {
                    question: "4. Which products are included in the promotion?",
                    answer: `
                  <p>
                    All Philadelphia products are included within the Philadelphia Brunch campaign. For a full list of participating products please visit the T&Cs page <a href="/terms-and-conditions/#products-list" rel="noopener noreferrer" target="_blank">here</a>.
                  </p>
                `}, {
                    question: "5. When can I enter?",
                    answer: `
                  <p>
                    The promotion runs from 10:00 BST on 07/07/25 to 17:00 BST on 30/09/25.
                  </p>
                `}, {
                    question: "6. Do I need to keep my receipt for the participating product until the end of the promotion?",
                    answer: `
                  <p>
                    Yes, if you live in England, Scotland, Wales, Northern Ireland, Channel Islands and Isle of Man, proof of purchase may be required to verify your claim - so don't throw it away.
                  </p>
                `}, {
                    question: "7.	Do I need internet access?",
                    answer: `
                  <p>
                    You will need internet access to enter the promotion.
                  </p>
                  <p>
                    You also need a valid email address in order to enter and claim a prize.
                  </p>
                `}
                  ])
                }
                
                </div>
<div className="faqs__section">
  <h2 className="type-h3 uppercase">Prize details, claiming and redemption</h2>
                {
                  renderFaqs(2, [{
                    question: "8.	What prizes are available?",
                    answer: `
                  <p>
                    There is 1 trip to New York City up for grabs for the winner and a guest, and includes flights from major cities, airport transfers, 4 night stay in New York, brunch and spending money. There are also 10 Brunch hampers available to be won, worth £275. Brunch hampers include a Smeg Retro Style 2 slice toaster; £100 gift card for either Deliveroo or UberEats, a pack of plain New York Bakery Co. bagels; and a Philadelphia selection pack including Philadelphia Original, Philadelphia Light, Philadelphia Garlic & Herb, Philadelphia Sweet Chilli, and Philadelphia Plant Based.
                  </p>
                `}, {
                    question: "9.	How will I know if I have won?",
                    answer: `
                  <p>
                    The Prize Draw will be conducted within 5 working days of the end of the promotion. Provisional Winners will be contacted via the email address provided on entry within 5 working days of Winner Selection and will be asked to provide evidence of identity and eligibility in line with the campaign <a href="/terms-and-conditions">T&C's</a>.
                  </p>
                `}, {
                    question: "10.	When can I take my trip to New York?",
                    answer: `
                  <p>
                    The holiday must be booked and taken by 30 September 2026, and at least 6 weeks' advance notice of the date you'd like to take your trip must be given. Unfortunately the following periods are excluded from the promotion: Valentine's Day, Christmas, New Year's Eve, Easter, school holidays and Bank holiday periods in the UK. 
                  </p>
                `},
                  {
                    question: "11.	What do I need in order to travel to New York?",
                    answer: `
                  <p>
                    You and your guest will need to hold a valid passport, and the passport must be valid for at least 6 months from the date of travel. You will also need to apply for any necessary visas or travel insurance before you travel, and ensure your visa has been approved before travelling. Unfortunately if you or your guest is unable to travel due to your visa or personal circumstances, no alternative tickets or compensation will be issued.
                  </p>
                `},
                  {
                    question: "12.	Is there a deadline for me to claim my brunch hamper?",
                    answer: `
                  <p>
                    Yes, you must respond to the  initial contact within 14 days before a reserve winner is drawn in place, in line with the campaign <a href="/terms-and-conditions">T&C's</a>.
                  </p>
                `}
                  ])
                }
                </div>
                <div className="faqs__section">
                <h2 className="type-h3 uppercase">On pack codes and entry mechanics</h2>
                {
                  renderFaqs(3, [{
                    question: "13.	What codes do I need to enter to participate?",
                    answer: `
                  <p>
                    If you live in England, Scotland, Wales or Northern Ireland you must enter both the barcode and batch code as part of your entry, which can be found on the back of your Philadelphia product.
                  </p>
                  <p>
                    Entrants in ROI do not need a code to enter, in line with the No Purchase Necessary process. 
                  </p>
                `}, {
                    question: "14.	I can't read my code",
                    answer: `
                  <p>
                    In some circumstances the batch code can be illegible or difficult to read. If you are having difficulties reading your code please contact our customer service team on <a href="tel:+44800818181">0800 818181</a> or at <a href="https://contactus.mdlzapps.com/philadelphiacouk/contact/en-UK/"  rel="noopener noreferrer" target="_blank">https://contactus.mdlzapps.com/philadelphiacouk/contact/en-UK/</a> who will be able to assist you.
                  </p>
                `}, {
                    question: "15. My code isn't working, am I entering the right code?",
                    answer: `
                  <p>
                    It can be confusing as products often feature many codes on the back of the pack for production reasons. Please double check you are entering the correct code within the required form field.
                  </p>
                  <p>
                    The barcode number is the 13-digit code directly under the barcode which is scanned in store. The batch code is the alpha-numerical code found on the back of your pack located directly above the “Best Before” date.
                  </p>
                `},
                    , {
                    question: "16.	I've already entered my code; can I enter it again for another chance to win?",
                    answer: `
                  <p>
                    Each entry needs to be accompanied by a new purchase, as the same code cannot be entered multiple times. 
                  </p>
                `},
                    , {
                    question: "17.	My code has been declined online and I get an error message, what can I do?",
                    answer: `
                    <ul>
                      <li>
                        <p><strong>If the error message is <i>'This code is not recognised'</i></strong></p>
                        <p>
                          Please check that you're trying to enter the right code. Products often feature many codes on the back of the pack for production reasons. The barcode number is the 13-digit code directly under the barcode which is scanned in store. The batch code is the digit alpha-numerical code found on the back of your pack located directly above the “Best Before” date.
                        </p>
                      </li>
                      <li>
                          <p><strong>If the error message is <i>'This code has already been used'</i></strong></p>
                          <p>
                            Remember, users are limited to one entry per person per email address per day. Only your first entry each day will be counted. Please note that there is a maximum of 20 entries per person during the entire Promotion Period.
                          </p>
                      </li>
                  </ul>           
                `},
                    , {
                    question: "18.	I entered the wrong email address. What should I do?",
                    answer: `
                  <p>
                    If you have entered an incorrect email address please contact our customer service team on please contact our customer service team on <a href="tel:+44800818181">0800 818181</a> or at <a href="https://contactus.mdlzapps.com/philadelphiacouk/contact/en-UK/" rel="noopener noreferrer" target="_blank">https://contactus.mdlzapps.com/philadelphiacouk/contact/en-UK/</a> who will be able to assist you.
                  </p>
                `}
                  ])
                }
                
              </div>
            </>
          }
        </div>
      </div>
    </section>
  </>;
}